export const AffinityData = [
  [ 'Сингапур', '18', '0.51' ],
  [ 'АСЕАН', '17.75', '0.5' ],
  [ 'Япония', '18', '0.51' ],
  [ 'Вьетнам', '16.5', '0.47' ],
  [ 'Малайзия', '16.25', '0.46' ],
  [ 'Китай', '15.5', '0.44' ],
  [ 'Австралия', '14.75', '0.42' ],
  [ 'Чили', '14.5', '0.41' ],
  [ 'Бруней Даруссалам', '14.25', '0.4' ],
  [ 'Новая Зеландия', '14', '0.4' ],
  [ 'Республика Корея', '14', '0.4' ],
  [ 'Таиланд', '13.5', '0.39' ],
  [ 'Перу', '11.75', '0.34' ],
  [ 'Мексика', '11.75', '0.34' ],
  [ 'Индия', '11.25', '0.32' ],
  [ 'США', '10.5', '0.3' ],
  [ 'Филиппины', '8.75', '0.25' ],
  [ 'Канада', '8.5', '0.24' ],
  [ 'Индонезия', '8.5', '0.24' ],
  [ 'Пакистан', '8.25', '0.24' ],
  [ 'Евросоюз', '7', '0.2' ],
  [ 'Мьянма', '6.25', '0.18' ],
  [ 'Гонконг', '5.5', '0.16' ],
  [ 'Шри-Ланка', '5', '0.14' ],
  [ 'Тайвань', '4.75', '0.13' ],
  [ 'ЕАЭС', '4.5', '0.13' ],
  [ 'Лаос', '4', '0.11' ],
  [ 'Камбоджа', '3.25', '0.09' ],
  [ 'Папуа-Новая Гвинея', '2.25', '0.06' ],
  [ 'Макао', '2', '0.06' ],
  [ 'Монголия', '1.5', '0.04' ],
  [ 'Бангладеш', '1.25', '0.04' ],
  [ 'Россия', '0.5', '0.01' ],
  [ 'Восточный Тимор', '0', '0' ],
  [ 'КНДР', '0', '0' ]
]